// extracted by mini-css-extract-plugin
export var bio = "author-module--bio--5sr-r";
export var image = "author-module--image--KxZfX";
export var imageWrapper = "author-module--imageWrapper--SCZoZ";
export var name = "author-module--name--HXDGU";
export var note = "author-module--note--9Ku8V";
export var position = "author-module--position--bmMtW";
export var sbShowMain = "author-module--sb-show-main--6YfgZ";
export var textWrapper = "author-module--textWrapper--Drkwh";
export var wrapper = "author-module--wrapper--loFGI";